
import React from 'react';
import { Link } from 'react-router-dom';
import { Building } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface CompanyDisplayProps {
  company: string;
  logo?: string;
  disableCompanyLink?: boolean;
}

const CompanyDisplay = ({ company, logo, disableCompanyLink = false }: CompanyDisplayProps) => {
  const encodedCompanyName = encodeURIComponent(company);
  
  const content = (
    <div className="flex items-center gap-2">
      {logo ? (
        <Avatar className="w-10 h-10">
          <AvatarImage src={logo} alt={company} />
          <AvatarFallback>
            <Building className="w-5 h-5 text-redflags-red" />
          </AvatarFallback>
        </Avatar>
      ) : (
        <Building className="w-5 h-5 text-redflags-red" />
      )}
      <h3 className="font-semibold text-lg">{company}</h3>
    </div>
  );

  if (disableCompanyLink) {
    return <div className="flex items-center gap-2 text-redflags-dark">{content}</div>;
  }

  return (
    <Link to={`/company/${encodedCompanyName}`} className="flex items-center gap-2 hover:text-redflags-red transition-colors">
      {content}
    </Link>
  );
};

export default CompanyDisplay;
